export default "__VITE_ASSET__DhgMbalN__"